<div class="content-width">


  <div id="printview">
    <div class="pageHeader" *ngIf="responseDetails!=null">Transaction Detail</div>
    <div class="errorMessage" *ngIf="errorMessage?.length">
      <br>
      You must correct the following error(s) before proceeding:
      <li *ngFor="let message of errorMessage">{{message}}</li>
    </div>
    <div [ngClass]=" containsError ? 'errorMessage' : 'warn-message'" *ngIf="validationMsg"><br>{{validationMsg}}</div>
    <div class="warn-message" *ngIf="warningMessage"><br>{{warningMessage}}</div>
    <div class="ui-g container grid-conatiner" *ngIf="responseDetails">

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Fannie Mae Loan Number:</div>
        <div class="ui-g-4"> {{responseDetails.LoanNum}} </div>
        <div class="ui-g-2 label-font">Transaction ID:</div>
        <div class="ui-g-4"> {{responseDetails.TranSysKey}} </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Servicer Number:</div>
        <div class="ui-g-4"> {{responseDetails.ServicerNum}} </div>
        <div class="ui-g-2 label-font">Creation Date:</div>
        <div class="ui-g-4"> {{responseDetails.CreationDate | date : 'MM/dd/yyyy hh:mm:ss a'}} </div>
      </div>
      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Effective Date:</div>
        <div class="ui-g-4"> {{responseDetails.EffectiveDate | date : 'MM/dd/yyyy'}} </div>
        <div class="ui-g-2 label-font">Transaction Amt:</div>
        <div class="ui-g-4"> {{responseDetails.TransactionAmt | currency}} </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Product Type:</div>
        <div class="ui-g-4"> {{responseDetails.ProductType}} </div>
        <div class="ui-g-2 label-font">Action Code:</div>
        <div class="ui-g-4"> {{responseDetails.ActionCode}} </div>
      </div>
      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Transaction Type:</div>
        <div class="ui-g-4"> {{responseDetails.TranType}} </div>
        <div class="ui-g-2 label-font">Reversed:</div>
        <div class="ui-g-4"> {{responseDetails.ReversedFlag}} </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-2 label-font">User ID:</div>
        <div class="ui-g-4"> {{responseDetails.userID}} </div>
        <div class="ui-g-2 label-font">Transaction Status:</div>
        <div class="ui-g-4"> {{responseDetails.TransStatus}} </div>
      </div>
    </div>
    <div  *ngIf="isReversible && !reverseClick && !clickYes" class="rev-link-align">
      <a (click)="reverse()" class="detail-link">Reverse Transaction</a>
    </div>
    <div class="button-right-cancel" *ngIf="!reverseClick && !clickYes">
      <button fmButton type="button" [primary]="true" label="Cancel" [small]="true"  (click)="cancel()"
            class="buttonmargin"></button>
    </div>

    <div class="button-right-cancel" *ngIf="reverseClick && !clickYes">
      <button fmButton type="button" [primary]="true" label="No" [small]="true"  (click)="No()"
            class="buttonmargin"></button>
      <button fmButton type="button" [primary]="true" label="Yes" [small]="true"  (click)="Yes()"
            class="buttonmargin"></button>
    </div>
  </div>
</div>
